import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
export default function useWindowSize() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    onResizeProp = _ref.onResize;
  var _useState = useState({
      width: undefined,
      height: undefined,
      loaded: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    windowSize = _useState2[0],
    setWindowSize = _useState2[1];
  useEffect(function () {
    if (!window) {
      return function () {
        return null;
      };
    }
    function handleResize() {
      var width = window.innerWidth;
      var height = window.innerHeight;
      setWindowSize({
        width: width,
        height: height,
        loaded: true
      });
      if (onResizeProp) {
        onResizeProp({
          width: width,
          height: height
        });
      }
    }
    window.addEventListener('resize', handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowSize;
}